/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { SagaIterator } from 'redux-saga';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  getEventTypesAdapter,
  getObjectCharacteristicsAdapter,
  getObjectTypesAdapter,
  getOfferFeaturesAdapter,
} from '../../adapters/ListingOptionsAdapter';
import {
  storeEventTypesAction,
  storeObjectCharacteristicsAction,
  storeObjectTypesAction,
  storeOfferFeaturesAction,
} from './ListingOptionsActionCreators';
import { ListingOptionsActionTypes } from './ListingOptionsActionTypes';
import { IdNameModel } from './ListingOptionsModels';

export function* getEventTypesSaga(action: any): SagaIterator {
  const eventTypes: IdNameModel[] = yield call(getEventTypesAdapter);

  yield put(storeEventTypesAction(eventTypes));
}

export function* getObjectTypesSaga(action: any): SagaIterator {
  const objectTypes: IdNameModel[] = yield call(getObjectTypesAdapter);

  yield put(storeObjectTypesAction(objectTypes));
}

export function* getObjectCharacteristicsSaga(action: any): SagaIterator {
  const objectCharacteristics: IdNameModel[] = yield call(getObjectCharacteristicsAdapter);

  yield put(storeObjectCharacteristicsAction(objectCharacteristics));
}

export function* getOfferFeaturesSaga(action: any): SagaIterator {
  const offerFeatures: IdNameModel[] = yield call(getOfferFeaturesAdapter);

  yield put(storeOfferFeaturesAction(offerFeatures));
}

export function* watchListingOptionsAsyncActions(): SagaIterator {
  yield all([
    takeEvery(ListingOptionsActionTypes.GET_EVENT_TYPES, getEventTypesSaga),
    takeEvery(ListingOptionsActionTypes.GET_OBJECT_TYPES, getObjectTypesSaga),
    takeEvery(ListingOptionsActionTypes.GET_OBJECT_CHARACTERISTICS, getObjectCharacteristicsSaga),
    takeEvery(ListingOptionsActionTypes.GET_OFFER_FEATURES, getOfferFeaturesSaga),
  ]);
}
